import ComponenteNumericoSubtipoModel from '../entities/formulario/componente/ComponenteNumericoSubtipoModel'

export default class CelulaComponenteOptions {
  constructor({
    id = 0,
    idFormularioSecao = 0,
    idElementoTipo = 0,
    filled = false,
    disabled = false,
    readonly = false,
    multiline = false,
    maxLength = null,
    visivel = false,
    mostrarIcones = false,
    obrigatorio = false,
    label = '',
    opcoes = [],
    texto = '',
    valueText = '',
    valueBoolean = false,
    valueOpcaoSelecionadaId = 0,
    componenteNumericoSubtipoId = null,
    componenteNumericoSubtipo = new ComponenteNumericoSubtipoModel(),
  } = {}) {
    this.id = id
    this.idFormularioSecao = idFormularioSecao
    this.idElementoTipo = idElementoTipo
    this.filled = filled
    this.disabled = disabled
    this.readonly = readonly
    this.multiline = multiline
    this.maxLength = maxLength
    this.visivel = visivel
    this.mostrarIcones = mostrarIcones
    this.obrigatorio = obrigatorio
    this.label = label
    this.opcoes = opcoes
    this.texto = texto
    this.valueText = valueText
    this.valueBoolean = valueBoolean
    this.valueOpcaoSelecionadaId = valueOpcaoSelecionadaId
    this.componenteNumericoSubtipoId = componenteNumericoSubtipoId
    this.componenteNumericoSubtipo = componenteNumericoSubtipo
  }
}
